/*
 * @Author: hzm
 * @Date: 2024-01-22 09:19:42
 * @Description: 
 */
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/zh-cn' // 导入本地化语言
dayjs.extend(updateLocale)
dayjs.extend(weekOfYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(quarterOfYear);
dayjs.locale('zh-cn') // 使用本地化语言
dayjs.updateLocale('zh-cn', {
  weekStart: 1
})

export const day = dayjs

export default day;

